import { useTranslation } from 'react-i18next';

import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './SmartParentProgramPopup.module.css';
import { getSmartParentsImage } from '../../../constants/images';

type SmartParentProgramPopupProps = {
  onPrimary: () => void;
  onCancel: () => void;
};

export const SmartParentProgramPopup = (
  props: SmartParentProgramPopupProps,
) => {
  const { onPrimary, onCancel } = props;

  const { t, i18n } = useTranslation();

  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onPrimary}
      onSecondaryButtonClick={onCancel}
      secondaryButtonLabel={t('Cancel')}
      primaryButtonLabel={t('Details')}
    >
      <div className={styles.popupContent}>
        <p className={styles.topTitle}>{t('Smart Parents Program')}</p>
        <p className={styles.title}>
          {t('Three-in-one: Recitation, Dictation, Exams')}
        </p>
        <p className={styles.subTitle}>
          {t(
            'Convert text into AI Memory Games, combined with AI-scheduled reviews, to boost memory effectiveness by up to 9 times!',
          )}
        </p>
        <img
          src={getSmartParentsImage('img1', i18n.language)}
          className={styles.smartImage1}
          alt="JOYAJOY Banner"
        />
        <p className={styles.subTitle}>
          {t('Join the program to create AI Memory Games!')}
        </p>
      </div>
    </BasicPopupContainer>
  );
};
